import React, { useState, useEffect } from "react";
import { useStorage, handleDraftFiltering } from '../../Utils/Utils';
import { gicsSectors } from '../../Utils/DummyData';
import Table from "../../components/Table/Table"
import RequestsTableRow from "./RequestsTableRow";

const RequestsLibraryTable = ({ setRequestsLoading, filters }) => {
	const [expandedRows, setExpandedRows] = useState([])
	const [tickers, setTickers] = useState([])
	const [requests, setRequests] = useState([])

	const storage = useStorage();

	useEffect(() => {
		storage.getOrFetch("/crm/tickers").then(setTickers)

		storage.refresh("/documents/requests")
			.then(filterSortAndSetData)
			.catch((err) => {
				console.error(err)
				setRequestsLoading(false)
			});
		storage.watch("/documents/requests", filterSortAndSetData);
		return () => storage.unwatch("/documents/requests")

	}, [])
	
		useEffect(() => {
			refreshList()
		}, [filters])

	const filterSortAndSetData = (drafts) => {
		let sortedDrafts = drafts.filter((doc) => {
			return handleDraftFiltering(doc.requestedAt, doc.ticker, filters)
		}).sort((a, b) => {
			if (a.date > b.date) return -1
			else if (a.date < b.date) return 1
			else return 0
		})
		setRequests(sortedDrafts)
		setRequestsLoading(false)
	}

	const refreshList = () => storage.refresh("/documents/requests").then(filterSortAndSetData)

	const getImage = (t) => {
		const sector = gicsSectors.find(s => s.name === t)
		const theTicker = tickers && tickers.find(ticker => ticker.ric === t)

		if (theTicker) return theTicker.logo
		else if (sector) return sector.image
		else return ""
	}

	const headerWidths = ["200px", "200px", "200px", "200px", "200px", "200px"];
	const headers = ["Request Date", "Last Edited", "Coverage", "Template", "Requestor", "Actions"];

	const dataMap = requests.map((document, idx) => {

		return <RequestsTableRow
			data={document}
			idx={idx}
			tickers={tickers}
			expandedRows={expandedRows}
			setExpandedRows={setExpandedRows}
			getImage={getImage}
			refreshList={refreshList}
		/>
	});

	return (
		<>
			<Table id="craigs-library-table" headerWidths={headerWidths} minWidth={1250} headers={headers} dataMap={dataMap} />
		</>
	);
}

export default RequestsLibraryTable;

export const RawDraftsLibraryTable = RequestsLibraryTable;
